export default "__VITE_ASSET__C2gvJz$Y__"